/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useCallback, useContext, useState } from 'react';

const RecipeContext = createContext();

export const RecipeProvider = ({ children }) => {
  const [recipe, setRecipe] = useState({});

  const updateRecipe = useCallback((newRecipe) => {
    setRecipe(newRecipe);
  }, []);

  return (
    <RecipeContext.Provider value={{ recipe, updateRecipe }}>{children}</RecipeContext.Provider>
  );
};

export function useRecipe() {
  const context = useContext(RecipeContext);
  if (!context) {
    throw new Error('useRecipe must be used within a RecipeProvider');
  }
  return context;
}
